export const COMMENTS_INPUT_ELEMENT = "comments-input-element";
